import React, { useContext, useState } from "react";
import "./PD.css";
import star_icon from "../Assets/star_icon.png";
import star_dull_icon from "../Assets/star_dull_icon.png";
import { ShopContext } from "../../Context/ShopContext";

const PD = (props) => {
    const { product } = props;
    const { addToCart } = useContext(ShopContext);
    const [selectedSize, setSelectedSize] = useState("M");


    return (
        <div className="product-display">
            <div className="product-display-left">
                <div className="image-gallery">
                    {[1, 2, 3, 4].map((item) => (
                        <div key={item} className="thumbnail">
                            <img style={{ width: "90px", height: "120px" }} src={product.image} alt={`Thumbnail ${item}`} />
                        </div>
                    ))}
                </div>
                <div className="main-image-container">
                    <img style={{ width: "400px", height: "500px" }} src={product.image} alt={product.name} className="main-image" />
                </div>
            </div>
            <div className="product-display-right">
                <h1 className="product-title">{product.name}</h1>
                
                <div className="rating-container">
                    <div className="stars">
                        {[1, 2, 3, 4].map((star) => (
                            <img key={star} src={star_icon} alt="Star" />
                        ))}
                        <img src={star_dull_icon} alt="Dull Star" />
                    </div>
                    <p className="review-count">(122 reviews)</p>
                </div>
                
                <div className="price-container">
                    <span className="old-price">{product.old_price} ETB</span>
                    <span className="new-price">{product.new_price} ETB</span>
                </div>
                
                <div className="description">
                    <p>{product.description}</p>
                </div>
                
                <div className="size-section">
                    <h2>Select Size</h2>
                    <div className="size-options">
                        {['S', 'M', 'L', 'XL'].map(size => (
                            <button
                                key={size}
                                className={`size-btn ${selectedSize === size ? 'selected' : ''}`}
                                onClick={() => setSelectedSize(size)}
                            >
                                {size}
                            </button>
                        ))}
                    </div>
                </div>
                
                <p className="category">
                    <span>Category: </span>Women, T-shirt, Crop
                </p>
                
                <button 
                    className="add-to-cart-btn"
                    onClick={() => {
                        addToCart(product.id, selectedSize);
                    }}
                >
                    Add to Cart
                </button>
            </div>
        </div>
    );
};

export default PD;